import {MemexColumnDataType} from '../api/columns/contracts/memex-column'
import {ItemType} from '../api/memex-items/item-type'
import {isPullRequestColumn, isValueEditableColumn} from '../models/column-capabilities'

export function columnEditable(itemType: ItemType, columnType: MemexColumnDataType) {
  // These column data types are never editable
  if (!isValueEditableColumn(columnType)) {
    return false
  }

  if (itemType === ItemType.RedactedItem) {
    return false
  }

  if (itemType === ItemType.PullRequest && !isPullRequestColumn(columnType)) {
    return false
  }

  // Parent issue does not support the "Convert to issue" flow like other issues only columns
  if (columnType === MemexColumnDataType.ParentIssue && itemType === ItemType.DraftIssue) {
    return false
  }

  // Items cannot be transferred to new repositories from within projects
  if (columnType === MemexColumnDataType.Repository && itemType !== ItemType.DraftIssue) {
    return false
  }

  return true
}
